import { nanoid } from 'nanoid'
import { ModalTypeList } from 'shared/ui/Modal/store/types'
import modalStore from 'shared/ui/Modal/store/modalStore'
import { type IDropOptions, type IInboxTreeCombine, TreeRootInboxes } from 'entities/Inbox'
import { type ConversationMenuStore } from 'pages/conversations/ui/ConversationMenu'

export const actionTeamsFavoriteDragDrop = async (
  options: IDropOptions<IInboxTreeCombine>,
  dropRoot: TreeRootInboxes,
  store: ConversationMenuStore
) => {
  const { dragSourceId, dragSource } = options
  const dragSourceElement =
    typeof dragSourceId === 'string' ? store.getItemTree(dragSourceId) : undefined
  const currentDropTargetId = dragSource?.parent ?? dragSourceElement?.parent
  const dragTarget =
    typeof currentDropTargetId === 'string' ? store.getItemTree(currentDropTargetId) : undefined
  const inbox = dragSource?.data ?? dragSourceElement?.data
  const groupInbox = dragTarget?.data

  const is_favorite = dropRoot === TreeRootInboxes.FAVORITE

  if (inbox && inbox.is_favorite !== is_favorite) {
    if (groupInbox?.type === 'inbox_group') {
      const modalId = nanoid()
      modalStore.addModal({
        id: modalId,
        type: ModalTypeList.ALERT,
        title: 'Remove inbox from group?',
        desc: `You're about to remove ${inbox.name} from the ${groupInbox.name} group inbox. This will affect all members of your organization.`,
        primaryAction: {
          text: 'Remove inbox',
          onAction: async () => {
            await store.updateFavorite({
              inbox,
              groupInbox,
              status: is_favorite,
            })
            modalStore.closeModal(modalId)
          },
        },
        secondaryAction: {
          text: 'Cancel',
          onAction: () => {
            modalStore.closeModal(modalId)
          },
        },
      })
      return
    }

    await store.updateFavorite({
      inbox: inbox,
      groupInbox: groupInbox,
      status: is_favorite,
    })
  }
}
